import "./Objects.scss";
import {
  MasterDataIcon,
  BusinessIcon,
  SearchIcon,
  MapPinIcon,
  ExternalLinkIcon,
  AddIcon,
  HouseIcon,
  ParkingIcon,
} from "../../../../../shared/cockpit/components/icons/Icon";

interface ObjectData {
  id: string;
  name: string;
  type: "FITNESS" | "GAMING" | "MFH";
  location: {
    address: string;
    city: string;
  };
  ownerCompany: string;
  details: {
    parking?: string;
    units?: string;
  };
}

const objectsData: ObjectData[] = [
  {
    id: "P1",
    name: "FitX Berlin-Alexanderplatz",
    type: "FITNESS",
    location: { address: "Alex 1", city: "10178 Berlin" },
    ownerCompany: "FitX Immobilien GmbH",
    details: { parking: "150 PP" },
  },
  {
    id: "P2",
    name: "Casino Royal Dortmund",
    type: "GAMING",
    location: { address: "Wall 5", city: "44137 Dortmund" },
    ownerCompany: "Spielstation Betriebs GmbH",
    details: { parking: "80 PP" },
  },
  {
    id: "P3",
    name: "Hafenquartier Hamburg",
    type: "MFH",
    location: { address: "Hafenstr. 12", city: "20457 Hamburg" },
    ownerCompany: "CaOs Wohnen GmbH",
    details: { units: "45 WE", parking: "50 PP" },
  },
  {
    id: "P4",
    name: "Wohnpark Süd Stuttgart",
    type: "MFH",
    location: { address: "Südallee 99", city: "70199 Stuttgart" },
    ownerCompany: "CaOs Wohnen GmbH",
    details: { units: "120 WE", parking: "140 PP" },
  },
];

function Objects() {
  return (
    <div className="objects-view">
      <header className="objects-view__header">
        <div className="objects-view__header__content">
          <div className="objects-view__header__title--container">
            <div className="objects-view__header__icon-wrapper">
              <MasterDataIcon />
            </div>
            <h2 className="objects-view__header__title">Objekte</h2>
          </div>

          <p className="objects-view__header__subtitle">
            Immobilien, Standorte und Liegenschaften der Schmidt Gruppe.
          </p>
        </div>
        <button className="objects-view__header__add-btn">
          <AddIcon /> Neues Objekt
        </button>
      </header>

      <div className="objects-view__content">
        <div className="objects-view__search-bar">
          <SearchIcon className="objects-view__search-icon" />
          <input type="text" placeholder="Objekt, Stadt oder ID suchen..." />
        </div>

        <div className="objects-table">
          <div className="objects-table__header">
            <div className="objects-table__col">OBJEKTNAME</div>
            <div className="objects-table__col">TYP</div>
            <div className="objects-table__col">STANDORT</div>
            <div className="objects-table__col">BESITZGESELLSCHAFT</div>
            <div className="objects-table__col">DETAILS</div>
            <div className="objects-table__col text-right">AKTION</div>
          </div>

          <div className="objects-table__body">
            {objectsData.map((obj) => (
              <div key={obj.id} className="objects-table__row">
                <div className="objects-table__col">
                  <div className="object-info">
                    <span className="object-info__name">{obj.name}</span>
                    <span className="object-info__id">ID: {obj.id}</span>
                  </div>
                </div>
                <div className="objects-table__col">
                  <span
                    className={`type-badge type-badge--${obj.type.toLowerCase()}`}
                  >
                    {obj.type}
                  </span>
                </div>
                <div className="objects-table__col">
                  <div className="location-info">
                    <MapPinIcon className="location-info__icon" />
                    <div className="location-info__text">
                      <span>{obj.location.address}</span>
                      <small>{obj.location.city}</small>
                    </div>
                  </div>
                </div>
                <div className="objects-table__col">
                  <div className="owner-info">
                    <BusinessIcon className="owner-info__icon" />
                    <span>{obj.ownerCompany}</span>
                  </div>
                </div>
                <div className="objects-table__col">
                  <div className="details-info">
                    {obj.details.units && (
                      <span className="details-info__item">
                        <HouseIcon /> {obj.details.units}
                      </span>
                    )}
                    {obj.details.parking && (
                      <span className="details-info__item">
                        <ParkingIcon /> {obj.details.parking}
                      </span>
                    )}
                  </div>
                </div>
                <div className="objects-table__col text-right">
                  <button className="action-btn">
                    <ExternalLinkIcon />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Objects;
